import React from 'react';

import typ from './index.d';
import { Modal, Separator } from './styles';
import InputComponent from '../../input';
import { toast } from 'react-toastify';
import { InterviewCRUD } from '../../../services/requests/interview';
import { useAppSelector } from '../../../hooks/useRedux';

const interviewCRUD = new InterviewCRUD();

const InterviewModal: React.FC<typ.Props> = ({
  onClose,
  personalClientId,
  data
}) => {

  // Redux
  const advisorId = useAppSelector(({ state }) => state.user?.id)
  
  
  // States
  const [company, setCompany] = React.useState(data?.company || '');
  const [statusInput, setStatusInput] = React.useState(data?.status || '');
  const [contact, setContact] = React.useState(data?.contact || '');
  const [vacancyName, setVacancyName] = React.useState(data?.vacancy_name || '')
  const [warning, setWarning] = React.useState({
    company: false,
    status: false,
    contact: false,
    vacancyName: false,
  });

  const createInterview = React.useCallback(
    async (
      company: string,
      status: string,
      contact: string,
      vacancyName: string,
    ) => {
      try {
        if (!company && !status && !contact && !vacancyName) {
          setWarning({
            company: true,
            status: true,
            contact: true,
            vacancyName: true,
          });
          toast('Digite todos os campos.');
          return;
        }
        if (!company) {
          setWarning(e => ({ ...e, company: true }));
          toast('Digite a empresa.');
          return;
        }
        if (!status) {
          setWarning(e => ({ ...e, status: true }));
          toast('Digite o status atual.');
          return;
        }
        if (!contact) {
          setWarning(e => ({ ...e, contact: true }));
          toast('Digite o contato');
          return;
        }
        if (!vacancyName) {
          setWarning(e => ({ ...e, vacancyName: true }));
          toast('Selecione a vaga relacionada.');
          return;
        }

        const { data, status: statusReq, error } = await interviewCRUD.create({
          vacancy_name: vacancyName,
          advisor_id: Number(advisorId),
          personal_client_id: personalClientId,
          company,
          status,
          contact,
        });

        if (error) throw new Error('Erro ao criar a entrevista');

        if (statusReq === 200) {
          toast('Entrevista associada com sucesso.');
          onClose();
        }
      } catch (e) {
        const { message } = e as Error;
        toast.error(message);
      }
    },
    [],
  );

  const editInterview = React.useCallback(
    async (
      id: number,
      company: string,
      status: string,
      contact: string,
      vacancyName: string,
    ) => {
      try {
        if (!company && !status && !contact && !vacancyName) {
          setWarning({
            company: true,
            status: true,
            contact: true,
            vacancyName: true,
          });
          toast('Digite todos os campos.');
          return;
        }
        if (!company) {
          setWarning(e => ({ ...e, company: true }));
          toast('Digite a empresa.');
          return;
        }
        if (!status) {
          setWarning(e => ({ ...e, status: true }));
          toast('Digite o status atual.');
          return;
        }
        if (!contact) {
          setWarning(e => ({ ...e, contact: true }));
          toast('Digite o contato');
          return;
        }
        if (!vacancyName) {
          setWarning(e => ({ ...e, vacancyName: true }));
          toast('Selecione a vaga relacionada.');
          return;
        }

        const { status: statusReq, error } = await interviewCRUD.update({
          interview_id: id || 0,
          vacancy_name: vacancyName,
          company,
          status,
          contact,
        });

        if (error) throw new Error('Erro ao editar entrevista');

        if (statusReq === 200) {
          toast('Entrevista editada com sucesso.');
          onClose();
        }
      } catch (e) {
        const { message } = e as Error;
        toast.error(message);
      }
    },
    [],
  );

  return (
    <Modal
      modalTitle={data ? `Editar entrevista` : `Adicionar entrevista`}
      onClose={onClose}
      buttonCallback={() => {
        if(!data) {
          createInterview(
            company,
            statusInput,
            contact,
            vacancyName
          );
          return
        }
        editInterview(
          data.id,
          company,
          statusInput,
          contact,
          vacancyName
        );
      }}
      buttonTitle={`Adicionar`}>
      <InputComponent
        placeholder="Nome da empresa"
        type="text"
        value={company}
        setValue={setCompany}
        warning={warning.company}
      />
      <Separator />
      <InputComponent
        customContainerSize="full"
        value={statusInput}
        setValue={setStatusInput}
        placeholder={'Status da entrevista'}
        warning={warning.status}
      />
      <Separator />
      <InputComponent
        customContainerSize="full"
        value={contact}
        setValue={setContact}
        warning={warning.contact}
        placeholder={'Contato da entrevista'}
      />
      <Separator />
      <InputComponent
        customContainerSize="full"
        placeholder={'Vaga da entrevista'}
        value={vacancyName}
        setValue={setVacancyName}
        customStyle={{ background: '#fff' }}
        warning={warning.vacancyName}
      />
    </Modal>
  );
};

export default InterviewModal;
